import React from 'react'
import {AUTH_PREFIX_PATH, APP_PREFIX_PATH} from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    }
]

const dashboardRoutes = [
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboard`,
        component: React.lazy(() => import('views/app-views')),
    },
]

const settingsRoutes = [
    {
        key: 'settings',
        path: `${APP_PREFIX_PATH}/settings/*`,
        component: React.lazy(() => import('views/app-views/settings')),
    },
]

const userRoutes = [
    {
        key: 'users',
        path: `${APP_PREFIX_PATH}/users`,
        component: React.lazy(() => import('views/app-views/users')),
        meta: {permission: 'list_user'},
    },
]

const identityRoutes = [
    {
        key: 'identities',
        path: `${APP_PREFIX_PATH}/identities`,
        component: React.lazy(() => import('views/app-views/identities')),
        meta: {permission: 'list_identities'},
    },
]

const contractRoutes = [
    {
        key: 'contracts',
        path: `${APP_PREFIX_PATH}/contracts`,
        component: React.lazy(() => import('views/app-views/contracts')),
        meta: {permission: 'list_contracts'},
    },

    {
        key: 'contract',
        path: `${APP_PREFIX_PATH}/contract`,
        component: React.lazy(() => import('views/app-views/contracts/add')),
        meta: {permission: 'create_contracts'},
    },
]

const roleRoutes = [
    {
        key: "roles",
        path: `${APP_PREFIX_PATH}/roles`,
        component: React.lazy(() => import("views/app-views/roles")),
        meta: {permission: 'list_role'}
    },
    {
        key: "roles_add",
        path: `${APP_PREFIX_PATH}/roles/add`,
        component: React.lazy(() => import("views/app-views/roles/add")),
    },
    {
        key: "roles_edit",
        path: `${APP_PREFIX_PATH}/roles/:id/edit`,
        component: React.lazy(() => import("views/app-views/roles/edit")),
    },
]

const materialGroupRoutes = [
    {
        key: "material_groups",
        path: `${APP_PREFIX_PATH}/material-groups`,
        component: React.lazy(() => import("views/app-views/material-groups")),
        meta: {permission: 'list_material_groups'}
    },
    {
        key: "material_groups_add",
        path: `${APP_PREFIX_PATH}/material-groups/add`,
        component: React.lazy(() => import("views/app-views/material-groups/add")),
        meta: {permission: 'create_material_groups'}
    },
    {
        key: "material_groups_edit",
        path: `${APP_PREFIX_PATH}/material-groups/edit/:id`,
        component: React.lazy(() => import("views/app-views/material-groups/add")),
        meta: {permission: 'create_material_groups'}
    },
]

const materialRoutes = [
    {
        key: "materials",
        path: `${APP_PREFIX_PATH}/materials`,
        component: React.lazy(() => import("views/app-views/materials")),
        meta: {permission: 'list_materials'}
    },
]

const organizationChartRoutes = [
    {
        key: "organization_charts",
        path: `${APP_PREFIX_PATH}/organization-charts`,
        component: React.lazy(() => import("views/app-views/organization-charts")),
        meta: {permission: 'list_organization_charts'}
    },
    {
        key: "organization_charts_show",
        path: `${APP_PREFIX_PATH}/organization-charts/:id`,
        component: React.lazy(() => import("views/app-views/organization-charts/show")),
        meta: {permission: 'read_organization_charts'}
    },
]

const configurationPointingRoutes = [
    {
        key: "configuration_pointings",
        path: `${APP_PREFIX_PATH}/configuration-pointings`,
        component: React.lazy(() => import("views/app-views/configuration-pointings")),
        meta: {permission: 'list_configuration_pointings'}
    }
]

const pointingRoutes = [
    {
        key: "pointages",
        path: `${APP_PREFIX_PATH}/pointages`,
        component: React.lazy(() => import("views/app-views/pointages")),
        meta: {permission: 'list_pointings'}
    },
    {
        key: "add_pointages",
        path: `${APP_PREFIX_PATH}/pointage`,
        component: React.lazy(() => import("views/app-views/pointages/add")),
        meta: {permission: 'create_pointings'}
    },
    {
        key: "pending_pointages",
        path: `${APP_PREFIX_PATH}/pointages/validation`,
        component: React.lazy(() => import("views/app-views/pointages/pendingValidation")),
        meta: {permission: 'validate_pointings'}
    },
    {
        key: "pointage_show",
        path: `${APP_PREFIX_PATH}/pointage/:id`,
        component: React.lazy(() => import("views/app-views/pointages/show")),
    },
    {
        key: "pointage_edit",
        path: `${APP_PREFIX_PATH}/pointage/:id/edit`,
        component: React.lazy(() => import("views/app-views/pointages/edit")),
        meta: {permission: 'update_pointings'}
    }
]

const leaveRoutes = [
    {
        key: "leaves",
        path: `${APP_PREFIX_PATH}/leaves`,
        component: React.lazy(() => import("views/app-views/leaves")),
        meta: {permission: 'list_leaves'}
    },
    {
        key: "leave_show",
        path: `${APP_PREFIX_PATH}/leave/:id`,
        component: React.lazy(() => import("views/app-views/leaves/show")),
    },
    {
        key: "holidays",
        path: `${APP_PREFIX_PATH}/holidays`,
        component: React.lazy(() => import("views/app-views/holidays")),
        meta: {permission: 'list_holidays'}
    }
]

const workCertificateRoutes = [
    {
        key: "work_certificates",
        path: `${APP_PREFIX_PATH}/work-certificates`,
        component: React.lazy(() => import("views/app-views/work-certificates")),
        meta: {permission: 'list_work_certificates'}
    },
    {
        key: "work_certificate_show",
        path: `${APP_PREFIX_PATH}/work-certificate/:id`,
        component: React.lazy(() => import("views/app-views/work-certificates/show")),
    }
]

const permissionRoutes = [
    {
        key: "permissions",
        path: `${APP_PREFIX_PATH}/permissions`,
        component: React.lazy(() => import("views/app-views/permissions")),
        meta: {permission: 'list_permissions'}
    },
    {
        key: "permission_show",
        path: `${APP_PREFIX_PATH}/permission/:id`,
        component: React.lazy(() => import("views/app-views/permissions/show")),
    }
]

const demandRoutes = [
    {
        key: "demand_store",
        path: `${APP_PREFIX_PATH}/demand`,
        component: React.lazy(() => import("views/app-views/demands/store")),
        meta: {permission: 'create_demands'}
    },
    {
        key: "demands",
        path: `${APP_PREFIX_PATH}/demands`,
        component: React.lazy(() => import("views/app-views/demands/demands")),
        meta: {permission: 'list_demands'}
    },
    {
        key: "demand_all",
        path: `${APP_PREFIX_PATH}/demands/all`,
        component: React.lazy(() => import("views/app-views/demands/all")),
        meta: {permission: 'list_all_demands'}
    },
    {
        key: "demand_pending",
        path: `${APP_PREFIX_PATH}/demands/pending`,
        component: React.lazy(() => import("views/app-views/demands/pending")),
        meta: {permission: 'pending_demands'}
    },
    {
        key: "demand_pending_treatment",
        path: `${APP_PREFIX_PATH}/demands/pending-treatment`,
        component: React.lazy(() => import("views/app-views/demands/pendingTreatment")),
        meta: {permission: 'pending_treatment_demands'}
    },
    {
        key: "demand_upcoming_treatment",
        path: `${APP_PREFIX_PATH}/demands/upcoming-treatment`,
        component: React.lazy(() => import("views/app-views/demands/upcomingTreatment")),
        meta: {permission: 'upcoming_treatment_demands'}
    },
    {
        key: "demand_processed",
        path: `${APP_PREFIX_PATH}/demands/processed`,
        component: React.lazy(() => import("views/app-views/demands/processed")),
        meta: {permission: 'processed_demands'}
    },
    {
        key: "demand_material_history",
        path: `${APP_PREFIX_PATH}/demands/material-history`,
        component: React.lazy(() => import("views/app-views/demands/materialHistory")),
        meta: {permission: 'list_demands'}
    },
    {
        key: "demand_show",
        path: `${APP_PREFIX_PATH}/demand/:id`,
        component: React.lazy(() => import("views/app-views/demands/show")),
        meta: {permission: 'read_demands'}
    },
    {
        key: "demand_edit",
        path: `${APP_PREFIX_PATH}/demand/:id/edit`,
        component: React.lazy(() => import("views/app-views/demands/edit")),
        meta: {permission: 'update_demands'}
    },
]

const typeRoutes = [
    {
        key: "list_types",
        path: `${APP_PREFIX_PATH}/types`,
        component: React.lazy(() => import("views/app-views/types")),
        meta: {permission: 'list_types'}
    },
    {
        key: "validation_level",
        path: `${APP_PREFIX_PATH}/validation-levels`,
        component: React.lazy(() => import("views/app-views/validation-levels")),
        meta: {permission: 'list_validation_levels'}
    },
    {
        key: "validation_circuits",
        path: `${APP_PREFIX_PATH}/validation-circuits`,
        component: React.lazy(() => import("views/app-views/validation-circuits")),
        meta: {permission: 'list_validation_circuits'}
    },
    {
        key: "workflow_definitions",
        path: `${APP_PREFIX_PATH}/workflow-definitions`,
        component: React.lazy(() => import("views/app-views/workflow-definitions")),
        meta: {permission: 'list_workflow_definitions'}
    },
]

const processingCircuitRoutes = [
    {
        key: "processing_circuits_add",
        path: `${APP_PREFIX_PATH}/processing-circuits/add`,
        component: React.lazy(() => import("views/app-views/processing-circuits/add")),
        meta: {permission: 'create_processing_circuits'}
    },
    {
        key: "processing_circuits_edit",
        path: `${APP_PREFIX_PATH}/processing-circuits/:id/edit`,
        component: React.lazy(() => import("views/app-views/processing-circuits/edit")),
        meta: {permission: 'update_processing_circuits'}
    },
    {
        key: "processing_circuits_index",
        path: `${APP_PREFIX_PATH}/processing-circuits`,
        component: React.lazy(() => import("views/app-views/processing-circuits")),
        meta: {permission: 'create_processing_circuits'}
    },
]

const analyticalAccountRoutes = [
    {
        key: "analytical_account_show",
        path: `${APP_PREFIX_PATH}/analytical-account/:id`,
        component: React.lazy(() => import("views/app-views/analytical-account/show")),
        meta: {permission: 'read_analytic_accounts'}
    },
    {
        key: "analytical_account",
        path: `${APP_PREFIX_PATH}/analytical-account`,
        component: React.lazy(() => import("views/app-views/analytical-account/index")),
        meta: {permission: 'list_analytic_accounts'}
    },
]

const singleRoutes = [
    {
        key: "partners",
        path: `${APP_PREFIX_PATH}/partners`,
        component: React.lazy(() => import("views/app-views/partners")),
        meta: {permission: 'list_partners'}
    },

    {
        key: "news",
        path: `${APP_PREFIX_PATH}/news`,
        component: React.lazy(() => import("views/app-views/news")),
        meta: {permission: 'list_news'}
    },

    {
        key: "realisations",
        path: `${APP_PREFIX_PATH}/realisations`,
        component: React.lazy(() => import("views/app-views/realisations")),
        meta: {permission: 'list_realisations'}
    },

    {
        key: "spontaneous_applications",
        path: `${APP_PREFIX_PATH}/spontaneous-applications`,
        component: React.lazy(() => import("views/app-views/spontaneous-applications")),
        meta: {permission: 'list_spontaneous_applications'}
    },

    {
        key: "subsidiaries",
        path: `${APP_PREFIX_PATH}/subsidiaries`,
        component: React.lazy(() => import("views/app-views/subsidiaries")),
        meta: {permission: 'list_subsidiaries'}
    },

    {
        key: "activities",
        path: `${APP_PREFIX_PATH}/activities`,
        component: React.lazy(() => import("views/app-views/activites")),
        meta: {permission: 'list_activities'}
    },

    {
        key: "executives",
        path: `${APP_PREFIX_PATH}/executives`,
        component: React.lazy(() => import("views/app-views/executives")),
        meta: {permission: 'list_executives'}
    },

    {
        key: "projects",
        path: `${APP_PREFIX_PATH}/projects`,
        component: React.lazy(() => import("views/app-views/projects")),
        meta: {permission: 'list_projects'}
    },

    {
        key: "projects_show",
        path: `${APP_PREFIX_PATH}/projects/:id`,
        component: React.lazy(() => import("views/app-views/projects/show")),
        meta: {permission: 'read_projects'}
    },

    {
        key: "bills_of_quantities_import",
        path: `${APP_PREFIX_PATH}/projects/:id/import-dqe`,
        component: React.lazy(() => import("views/app-views/projects/billOfQuantityImport")),
        meta: {permission: 'update_projects'}
    },

    {
        key: "plannings_show",
        path: `${APP_PREFIX_PATH}/projects/:id/plannings/:planningId`,
        component: React.lazy(() => import("views/app-views/projects/planning")),
        meta: {permission: 'read_plannings'}
    },

    {
        key: "bills_of_quantities_show",
        path: `${APP_PREFIX_PATH}/bills-of-quantities/:id`,
        component: React.lazy(() => import("views/app-views/projects/billOfQuantities")),
        meta: {permission: 'read_projects'}
    },

    {
        key: "services",
        path: `${APP_PREFIX_PATH}/services`,
        component: React.lazy(() => import("views/app-views/services")),
        meta: {permission: 'list_services'}
    },
]

const jobOffersRoutes = [
    {
        key: "job_offers",
        path: `${APP_PREFIX_PATH}/job-offers`,
        component: React.lazy(() => import("views/app-views/job-offers")),
        meta: {permission: 'list_job_offers'}
    },
    {
        key: "job_offers_show",
        path: `${APP_PREFIX_PATH}/job-offers/:id`,
        component: React.lazy(() => import("views/app-views/job-offers/show")),
        meta: {permission: 'read_job_offers'}
    },
    {
        key: "job_applications",
        path: `${APP_PREFIX_PATH}/job-applications`,
        component: React.lazy(() => import("views/app-views/job-applications")),
        meta: {permission: 'list_job_applications'}
    },
]

// Guide d'utilisation : visible par tout utilisateur connecté ;
// chaque page de module filtre elle-même selon les permissions.
const guideRoutes = [
    {
        key: "guide",
        path: `${APP_PREFIX_PATH}/guide`,
        component: React.lazy(() => import("views/app-views/guide")),
    },
    {
        key: "guide_module",
        path: `${APP_PREFIX_PATH}/guide/:slug`,
        component: React.lazy(() => import("views/app-views/guide/show")),
    },
]

// const purchaseOrderRoutes = [
//     {
//         key: "purchase_orders_add",
//         path: `${APP_PREFIX_PATH}/purchase-order`,
//         component: React.lazy(() => import("views/app-views/purchase-order/store")),
//         meta: {permission: 'create_purchase_orders'}
//     },
// ]

export const protectedRoutes = [
    ...dashboardRoutes,
    ...settingsRoutes,
    ...userRoutes,
    ...identityRoutes,
    ...roleRoutes,
    ...materialGroupRoutes,
    ...materialRoutes,
    ...organizationChartRoutes,
    ...demandRoutes,
    ...typeRoutes,
    ...processingCircuitRoutes,
    ...analyticalAccountRoutes,
    ...contractRoutes,
    ...configurationPointingRoutes,
    ...pointingRoutes,
    ...leaveRoutes,
    ...workCertificateRoutes,
    ...permissionRoutes,
    ...singleRoutes,
    ...jobOffersRoutes,
    ...guideRoutes
    // ...purchaseOrderRoutes
]
